import type { JiraInstanceData } from "../components/dropdowns/JiraInstance";

export function getJiraInstanceSignature(instance: JiraInstanceData): string {
  const spaces = instance.spaces
    .map((space) => ({
      key: space.key,
      name: space.name,
      workTypes: space.workTypes
        .map((workType) => ({
          iconUrl: workType.iconUrl,
          name: workType.name,
        }))
        .sort((a, b) =>
          `${a.name}:${a.iconUrl}`.localeCompare(`${b.name}:${b.iconUrl}`),
        ),
    }))
    .sort((a, b) => `${a.key}:${a.name}`.localeCompare(`${b.key}:${b.name}`));

  return JSON.stringify({
    clientId: instance.clientId ?? null,
    defaultSpaceKey: instance.defaultSpace?.key ?? null,
    defaultWorkTypeName: instance.defaultWorkType?.name ?? null,
    issueLimitSoft: instance.issueLimitSoft ?? null,
    issueLimitHard: instance.issueLimitHard ?? null,
    spaces,
    url: instance.url,
    username: instance.username,
  });
}
